import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Slider } from "@/components/ui/slider";
import { RulesFields } from "@/components/RulesFields";
import { LogoField } from "@/components/contest-form/LogoField";

export function BasicInfoSection({ form, set, merge }) {
  const probValue = [form.win_probability * 100];
  return (
    <>
      <div className="space-y-1.5">
        <Label>Nome concorso *</Label>
        <Input data-testid="contest-name-input" value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Es. Concorso Natale 2026" />
      </div>
      <div className="space-y-1.5">
        <Label>Descrizione</Label>
        <Textarea data-testid="contest-description-input" value={form.description} onChange={(e) => set("description", e.target.value)} placeholder="Breve descrizione del concorso" />
      </div>
      <LogoField form={form} set={set} />
      <div className="rounded-xl border border-border p-4 space-y-3" data-testid="contest-rules-section">
        <p className="font-semibold text-sm">Regolamento e contatti</p>
        <RulesFields value={form} onChange={merge} />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label>Inizio (data e ora) *</Label>
          <Input data-testid="contest-start-input" type="datetime-local" value={form.start_datetime} onChange={(e) => set("start_datetime", e.target.value)} />
        </div>
        <div className="space-y-1.5">
          <Label>Fine (data e ora) *</Label>
          <Input data-testid="contest-end-input" type="datetime-local" value={form.end_datetime} onChange={(e) => set("end_datetime", e.target.value)} />
        </div>
      </div>
      <div className="space-y-2 rounded-lg bg-secondary/40 p-4">
        <div className="flex items-center justify-between">
          <Label>Probabilità di vincita</Label>
          <span className="font-mono-code font-bold text-primary" data-testid="win-probability-value">{Math.round(form.win_probability * 100)}%</span>
        </div>
        <Slider data-testid="win-probability-slider" value={probValue} onValueChange={(v) => set("win_probability", v[0] / 100)} min={1} max={100} step={1} />
        <p className="text-xs text-muted-foreground">Applicata quando sono ancora disponibili premi giornalieri.</p>
      </div>
    </>
  );
}
